export default {
    requests: 0,
    login: JSON.parse(localStorage.getItem('login') || '{}'),
    user_rules: JSON.parse(localStorage.getItem('user_rules') || '[]'),
    namespace: {}
}
